var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRulesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21L14 21C14.394 21.0002 14.7843 20.9228 15.1483 20.7721C15.5124 20.6215 15.8432 20.4005 16.1219 20.1219C16.4005 19.8432 16.6215 19.5124 16.7721 19.1483C16.9228 18.7843 17.0002 18.394 17 18L17 3L8 3C7.73735 2.99999 7.47727 3.05171 7.23462 3.15221C6.99196 3.25272 6.77148 3.40004 6.58576 3.58576C6.40004 3.77148 6.25272 3.99196 6.15221 4.23462C6.05171 4.47727 5.99999 4.73735 6 5L6 13.5L15 13.5L15 18C15.0001 18.089 14.9881 18.1777 14.9644 18.2635C14.901 18.4971 14.7548 18.6997 14.5532 18.8336C14.3515 18.9674 14.1081 19.0235 13.8682 18.9912C13.6283 18.959 13.4082 18.8406 13.2491 18.6583C13.0899 18.4759 13.0025 18.2419 13.003 17.9998L13.0001 15.0083L13.0001 14.9998L3.0094 14.9998L3 18C3.0006 18.7955 3.31686 19.5582 3.87934 20.1207C4.44182 20.6831 5.20453 20.9994 6 21Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulesIcon);
export default __webpack_public_path__ + "static/media/rules-icon.c4601096.svg";
export { ForwardRef as ReactComponent };